export type ApiMode = "fixtures" | "live";

/** Read at call time so tests can stub the env. Default: fixtures. */
export function getApiMode(): ApiMode {
  return import.meta.env.VITE_API_MODE === "live" ? "live" : "fixtures";
}

/** Artificial latency in fixtures mode so loading states are real. */
export function getFixtureDelayMs(): number {
  const n = Number(import.meta.env.VITE_API_DELAY_MS ?? 150);
  return Number.isFinite(n) && n >= 0 ? n : 150;
}
